module.exports = __webpack_public_path__ + "img/ic_house.46f57010.svg";